import { createPortal } from "react-dom";
import { Window, Container } from "./styles";
import useBodyScrollByPortalElements from "utils/hooks/useBodyScrollByPortalElements";
import { PORTAL_WRAPPER_ID } from "utils/constants";

const $portals = document.getElementById(PORTAL_WRAPPER_ID);
const CustomDialogAlert = ({
    dialog, className, children, 
    closeDialog,
    width, zIndex
}) => {
    useBodyScrollByPortalElements({
		flag: dialog.value
	});
    const getClassName = () => {
        const classList = [];
        if (className)
            classList.push(className);
        if (!dialog.value)
            classList.push("hidden");
        return classList.join(" ");
    }
    return createPortal(
        <Container 
            zIndex={zIndex}
            className={getClassName()}
            onClick={closeDialog ?? dialog.hide}>
            <Window onClick={e => e.stopPropagation()} width={width}>
                {children}
            </Window>
        </Container>, 
        $portals
    );
}

export default CustomDialogAlert;